import React, { memo } from 'react'
import ControlledCheckbox from 'transfix-form/components/ControlledCheckbox'
import { makeStyles } from 'transfix-ui/core'
import Grid from 'transfix-ui/core/Grid'
import { brandColors } from 'transfix-ui/theme/colors'
import CarrierStatusCard, {
  ICarrierStatusCardProps,
} from 'apps/marketplace/components/CarrierStatusCard'
import { useCoverModalFormContext } from '../../hooks/useCoverModalForm'
import CarrierInformationFormGroup, {
  ICarrierInformationFormGroupProps,
} from '../CoverModalForm/CarrierInformationFormGroup'
import DriverInformationFormGroup, {
  IDriverInformationFormGroupProps,
} from '../CoverModalForm/DriverInformationFormGroup'

const useCoverageFormBodyStyles = makeStyles(theme => ({
  tracking: {
    '& label': {
      display: 'flex',
      alignItems: 'center !important',
      margin: '0',
      padding: theme.spacing(2),
      backgroundColor: brandColors.coolGray0,
      gap: theme.spacing(1),
    },
    '& span, & div': {
      height: '100%',
      padding: `0 !important`,
      margin: '0',
      display: 'flex',
      alignItems: 'center',
    },
  },
}))

const TRACKING_LABEL =
  'I have conveyed to the dispatcher that tracking through the app is required.'

export interface ICoverageFormBodyProps
  extends Pick<ICarrierStatusCardProps, 'shipmentId' | 'onCarrierRequirementsLoaded'>,
    ICarrierInformationFormGroupProps,
    IDriverInformationFormGroupProps {}

const CoverageFormBody = memo<ICoverageFormBodyProps>(
  ({
    dispatcher,
    driver,
    isCovered,
    onCarrierRequirementsLoaded,
    onSelectCarrier,
    pickupTime,
    selectedCarrier,
    setSelectedContactUserId,
    shipmentId,
    shipmentTimezone,
  }) => {
    const classes = useCoverageFormBodyStyles()
    const { control } = useCoverModalFormContext()
    const { id: carrierApplicationId } = selectedCarrier || {}
    return (
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <CarrierInformationFormGroup
            selectedCarrier={selectedCarrier}
            dispatcher={dispatcher}
            isCovered={isCovered}
            onSelectCarrier={onSelectCarrier}
            setSelectedContactUserId={setSelectedContactUserId}
          />
        </Grid>
        <Grid item xs={6}>
          <CarrierStatusCard
            carrierApplicationId={carrierApplicationId}
            shipmentId={shipmentId}
            onCarrierRequirementsLoaded={onCarrierRequirementsLoaded}
          />
        </Grid>
        <Grid item xs={12}>
          <hr />
        </Grid>
        <Grid item xs={12}>
          <DriverInformationFormGroup
            selectedCarrier={selectedCarrier}
            pickupTime={pickupTime}
            shipmentTimezone={shipmentTimezone}
            driver={driver}
          />
        </Grid>
        <Grid item xs={12}>
          <hr />
        </Grid>
        <Grid item xs={12}>
          <div className={classes.tracking}>
            <ControlledCheckbox
              control={control}
              name='trackingRequired'
              CheckboxProps={{
                dataTest: 'sd-coverage-form-tracking',
                label: TRACKING_LABEL,
              }}
            />
          </div>
        </Grid>
      </Grid>
    )
  }
)

export default CoverageFormBody
